export default "__VITE_ASSET__DGlZh4Lg__"